import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_component_svg_icon, {
    width: _ctx.width,
    height: _ctx.height,
    iconColor: _ctx.iconColor,
    viewBoxWidth: "24",
    viewBoxHeight: "24"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("line", {
        x1: "4",
        y1: "21",
        x2: "4",
        y2: "14"
      }, null, -1),
      _createElementVNode("line", {
        x1: "4",
        y1: "10",
        x2: "4",
        y2: "3"
      }, null, -1),
      _createElementVNode("line", {
        x1: "12",
        y1: "21",
        x2: "12",
        y2: "12"
      }, null, -1),
      _createElementVNode("line", {
        x1: "12",
        y1: "8",
        x2: "12",
        y2: "3"
      }, null, -1),
      _createElementVNode("line", {
        x1: "20",
        y1: "21",
        x2: "20",
        y2: "16"
      }, null, -1),
      _createElementVNode("line", {
        x1: "20",
        y1: "12",
        x2: "20",
        y2: "3"
      }, null, -1),
      _createElementVNode("line", {
        x1: "1",
        y1: "14",
        x2: "7",
        y2: "14"
      }, null, -1),
      _createElementVNode("line", {
        x1: "9",
        y1: "8",
        x2: "15",
        y2: "8"
      }, null, -1),
      _createElementVNode("line", {
        x1: "17",
        y1: "16",
        x2: "23",
        y2: "16"
      }, null, -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["width", "height", "iconColor"]))
}